module.exports = __webpack_public_path__ + "static/media/bg@2x.d9551f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/bg@2x.png
// module id = 1115
// module chunks = 0